document.addEventListener('DOMContentLoaded', () => {
  // AutoChimp 21 Sep 2026 (Daniel): the shake is a PRODUCT PAGE feature only.
  // This file loads site-wide (layout/theme.liquid), and its selector also caught the
  // Add to cart buttons on the homepage Best sellers cards. Body carries
  // class="template-{{ template.name }}", so anything that isn't a product page stops here.
  if (!document.body.classList.contains('template-product')) return;

  const SETTINGS = {
    interval: 9000,
    animationClass: 'autochimp-cart-shake'
  };

  function getButtons() {
    const candidates = document.querySelectorAll(`
      form[action*="/cart/add"] button,
      button[name="add"],
      .product-form__submit,
      .add-to-cart,
      [data-add-to-cart]
    `);

    return Array.from(candidates).filter((button) => {
      const text = button.textContent.trim().toLowerCase();

      return (
        text.includes('add to cart') ||
        text.includes('add this') ||
        button.name === 'add'
      );
    });
  }

  function shake(button) {
    if (!button || button.disabled) return;

    button.classList.remove(SETTINGS.animationClass);
    void button.offsetWidth;
    button.classList.add(SETTINGS.animationClass);
  }

  function initCartShaker() {
    const buttons = getButtons();

    buttons.forEach((button) => {
      if (button.dataset.autochimpCartShaker === 'true') return;

      button.dataset.autochimpCartShaker = 'true';

      button.addEventListener('mouseenter', () => {
        shake(button);
      }, { passive: true });

      setInterval(() => {
        shake(button);
      }, SETTINGS.interval);
    });
  }

  initCartShaker();

  document.addEventListener('shopify:section:load', initCartShaker);
});